import { Grid, SxProps, Theme, Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { lineItemNoteBrands } from 'shared/constants';
import { FormTextField, NumberTextField } from 'shared/controls';
import { Brands, ICustomProduct } from 'shared/types';
import { buildCustomProductFieldNameWithIndex } from 'shared/utility';
import { CustomProductLineItemNotes } from './custom-product-line-item-notes';

const rootStyles: SxProps<Theme> = {
  width: '100%',
  position: 'relative',
};

interface ICustomProductCardProps {
  customProduct: ICustomProduct;
  editMode: boolean;
  index: number;
}
export function CustomProductCard({ customProduct, editMode, index }: ICustomProductCardProps) {
  const { brand } = useParams<{ brand: Brands }>();

  const isLineItemNoteBrand: boolean = lineItemNoteBrands.includes(brand);

  const buildFieldName = buildCustomProductFieldNameWithIndex<ICustomProduct>(index);
  const { setValue } = useFormContext();

  const quantityChange = (customProductQuantity: number) => {
    setValue(buildFieldName('customProductQuantity'), customProductQuantity);
  };

  const priceChange = (customProductPrice: number) => {
    setValue(buildFieldName('customProductPrice'), customProductPrice);
  };

  return (
    <Box sx={rootStyles}>
      <Grid item xs container spacing={6}>
        <Grid item xs={12} lg>
          {editMode ? (
            <FormTextField
              label='Custom Product'
              name={buildFieldName('customProductName')}
              defaultValue={customProduct.customProductName}
            />
          ) : (
            <FormTextField
              label='Custom Product'
              name={buildFieldName('customProductName')}
              defaultValue={customProduct.customProductName}
              disabled
            />
          )}
        </Grid>
        <Grid item xs={12} lg>
          {editMode ? (
            <NumberTextField
              label='Quantity'
              name={buildFieldName('customProductQuantity')}
              defaultValue={Number(customProduct.customProductQuantity)}
              onChangeValue={quantityChange}
            />
          ) : (
            <NumberTextField
              label='Quantity'
              name={buildFieldName('customProductQuantity')}
              defaultValue={Number(customProduct.customProductQuantity)}
              disabled
            />
          )}
        </Grid>
        <Grid item xs={12} lg>
          {editMode ? (
            <NumberTextField
              label='Price'
              name={buildFieldName('customProductPrice')}
              defaultValue={Number(customProduct.customProductPrice)}
              prefix='$'
              fixedDecimalScale
              decimalScale={2}
              onChangeValue={priceChange}
            />
          ) : (
            <NumberTextField
              label='Price'
              name={buildFieldName('customProductPrice')}
              defaultValue={Number(customProduct.customProductPrice)}
              decimalScale={2}
              prefix='$'
              fixedDecimalScale
              disabled
            />
          )}
        </Grid>
        {isLineItemNoteBrand && (
          <CustomProductLineItemNotes customProduct={customProduct} editMode={editMode} index={index} />
        )}
      </Grid>
    </Box>
  );
}
